import CryptoJS from "crypto-js";

interface EncryptionParams {
    key: string;
    iv: string;
}

export const encryptData = (data: unknown, { key, iv }: EncryptionParams) => {
    const msg = JSON.stringify(data);
    const parsedIv = CryptoJS.enc.Utf8.parse(iv);
    const parsedKey = CryptoJS.enc.Utf8.parse(key);
    const encryptedData = CryptoJS.AES.encrypt(msg, parsedKey, {
        iv: parsedIv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    return encryptedData.toString();
};

export const decryptData = (encryptedBase64: string, { key, iv }: EncryptionParams): unknown => {
    const parsedIv = CryptoJS.enc.Utf8.parse(iv);
    const parsedKey = CryptoJS.enc.Utf8.parse(key);

    const decrypted = CryptoJS.AES.decrypt(encryptedBase64, parsedKey, {
        iv: parsedIv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });

    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

    try {
        return JSON.parse(decryptedText);
    } catch {
        return decryptedText; // In case it's not JSON (e.g., just a string)
    }
};
